import BaseService from "../base.service";
import { getResponseQuery } from "../../helpers/_functions";
import http from "../../http-common";

class EvaluationCriteria extends BaseService {
  constructor() {
    super("evaluation-criteria");
  }

  createEvaluationCriteria = (data) => getResponseQuery(super.insert(data));
  updateEvaluationCriteria = (evaluationCriteria) => getResponseQuery(super.updateById(evaluationCriteria));
  updateOrderEvaluationCriteria = (arrayEvalutionsCriteria) => getResponseQuery(super.updateOrder(arrayEvalutionsCriteria));
  deleteEvaluationCriteria = (evaluationCriteriaId) => getResponseQuery(super.deleteById(evaluationCriteriaId));
  duplicateEvaluationCriteria = (evaluationCriteria) => getResponseQuery(http.put(`${this.path}/duplicate`, evaluationCriteria));
}

export default new EvaluationCriteria();